import { render, staticRenderFns } from "./billManagement.vue?vue&type=template&id=6ada7874&scoped=true&"
import script from "./billManagement.vue?vue&type=script&lang=js&"
export * from "./billManagement.vue?vue&type=script&lang=js&"
import style0 from "./billManagement.vue?vue&type=style&index=0&id=6ada7874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ada7874",
  null
  
)

export default component.exports